module.exports = __webpack_public_path__ + "static/pay-master-063b13c0648c15f712676884f64b46a7.svg";